import React from 'react';

import Dashboard from '../components/Dashboard/Dashboard';
import Logout from 'components/Auth/Logout';
import LoginPage from 'components/Auth/LoginPage';

import AllDevicesPage from '../components/Devices/AllDevicesPage';
import AllUsersPage from '../components/User/AllUsersPage';
import UsersPage from '../components/User/UsersPage';

import {Outlet, RouterProvider, createBrowserRouter} from 'react-router-dom';
import AdminRoute from './AdminRoute';
import {MyEventsRoutes, MySubEventsRoutes} from './EventsRoutes';
import {ResourceContextProvider} from 'components/record/ResourceContext';
import DevicesPage from 'components/Devices/DevicesPage';
import LogsPage from 'components/LogsComponents/LogsPage';
import ResourceRecordContextProvider from 'components/record/ResourceRecordProvider';
import LogShow from 'components/LogsComponents/LogShow';
import ConfigurationsPage from 'components/Configurations/ConfigurationsPage';
import RolesPage from 'components/Roles/RolesPage';
import EntriesPage from 'components/Entry/EntriesPage';

const MainRouter = () => {
  // Define routes accessible only to authenticated users
  const routesForAuthenticatedOnly = [
    {
      path: '/',
      element: <AdminRoute />, // Wrap the component in ProtectedRoute
      children: [
        {
          path: '/',
          element: <Dashboard />
        },
        MyEventsRoutes,
        MySubEventsRoutes,
        {
          path: '/my_devices',
          element: (
            <ResourceContextProvider resource="Device">
              <DevicesPage />
            </ResourceContextProvider>
          )
        },
        {
          path: '/entries',
          element: (
            <ResourceContextProvider resource="AllEntry">
              <EntriesPage />
            </ResourceContextProvider>
          )
        },
        {
          path: '/users',
          element: <UsersPage />
        },
        {
          path: '/all_devices',
          element: <AllDevicesPage />
        },
        {
          path: '/all_users',
          element: <AllUsersPage />
        },
        {
          path: '/logs',
          element: (
            <ResourceContextProvider resource="Log">
              <Outlet />
            </ResourceContextProvider>
          ),
          children: [
            {
              path: '/logs/',
              element: <LogsPage />
            },
            {
              path: '/logs/:id',
              element: (
                <ResourceRecordContextProvider param="id">
                  <LogShow />
                </ResourceRecordContextProvider>
              )
            }
          ]
        },
        {
          path: '/configurations',
          element: (
            <ResourceContextProvider resource="Configuration">
              <ConfigurationsPage />
            </ResourceContextProvider>
          )
        },
        {
          path: '/roles',
          element: (
            <ResourceContextProvider resource="Role">
              <RolesPage />
            </ResourceContextProvider>
          )
        },
        {
          path: '/logout',
          element: <Logout />
        }
      ]
    }
  ];

  // Define routes accessible only to non-authenticated users
  const routesForNotAuthenticatedOnly = [
    {
      path: '/login',
      element: <LoginPage />
    }
  ];

  // Combine and conditionally include routes based on authentication status
  const router = createBrowserRouter([...routesForNotAuthenticatedOnly, ...routesForAuthenticatedOnly]);

  return <RouterProvider router={router} />;
};

export default MainRouter;
